module.exports = __webpack_public_path__ + "img/133.ce060950.jpg";